var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg","name":_vm.iconName,"width":"100%","height":"100%"}},[_c('rect',{attrs:{"x":"0","y":"0","width":_vm.scaledWidth,"height":_vm.scaledHeight,"fill":"none","stroke":"#F8F8F8","stroke-width":"2","rx":"5","ry":"5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }